import { createContext } from 'react';

export const AppStateContext = createContext(null);
export const AppDispatchContext = createContext(null);

export const initialState = {
  posts: [],
  loadingPosts: false,
  loadingPostsError: false,
  initialPostsFetched: false,
  postsPagination: {
    totalPages: null,
    currentPage: null,
    hasPrevPage: null,
    hasNextPage: null,
    nextPage: null,
    prevPage: null,
  },
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'SET-POSTS':
      return {
        ...state,
        posts: action.payload,
        initialPostsFetched: action.postsFetched,
      };

    case 'SET-PAGINATION':
      return {
        ...state,
        postsPagination: action.payload,
      };

    case 'SET-LOADING-POSTS':
      return {
        ...state,
        loadingPosts: action.payload,
      };

    case 'SET-LOADING-POSTS-ERROR':
      return {
        ...state,
        loadingBlogPostsError: action.payload,
      };

    default:
      return state;
  }
};
